import React from 'react';
import { Steps } from '@ss/mtd-react';
import { StepsProps } from '@src/types/components';
import { customReport } from '@src/utils/customReport';
import { doAction, getServiceType } from '../../utils';
import flowConfig from './flowConfig.json';
import { TipInfo, Header } from '../../components';
import Url from './url';
import './index.scss';

interface Props {
  [K: string]: DefaultAny;
}

interface State {
  tipConfig?: {
    status: StepsProps['status'] | number;
    isSign: number;
    userName?: string;
    step?: string;
  };
  notNeedCheck: boolean;
}

interface HandleGetFlow {
  config?: {
    hash?: string;
    link?: string;
    title?: string;
    url?: string;
  }[];
  status?: StepsProps['status'];
  step?: string;
}

const { Step } = Steps;

// home页面，显示当前流程进度，以及提示信息
class Home extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.flow = [];
    this.flowConfig = flowConfig;
    this.state = {
      tipConfig: null,
      notNeedCheck: false,
    };
  }

  flow: any[];

  flowConfig: { url: string; title: string; buttonName?: string; link?: string; hash?: any }[];

  async componentDidMount() {
    await getServiceType();
    const tipConfig = await doAction(Url.homeDetail, {}, null);
    this.setState({
      tipConfig,
      notNeedCheck: window.checkTypeIndex === 0, // 如果为true则需要背调
    });

    customReport(`进入 cli3 houxuanren home ${tipConfig?.userName || ''} ${process.env.BLOCK_ENV}`);
  }

  handleButtonClick = (hash?: string, link?: string) => {
    if (hash) {
      const tenantUid = window.location.hash.split('/')[2];
      window.location.hash = `#/candidate/${tenantUid}/`;
      return;
    }
    window.open(link);
  };

  // 流程组件
  handleGetFlow = (val: HandleGetFlow) => {
    const { config, status, step } = val;
    const stepMap: { [key: string]: number } = {};
    config
      .filter((s) => s)
      .forEach(({ url }, i) => {
        stepMap[url] = i;
      });
    const activeMap = {
      1: stepMap.step1,
      2: stepMap.step3,
      3: stepMap.step3,
      4: stepMap.step4,
      5: stepMap.step5,
    };
    return (
      <Steps active={activeMap[step] ?? step} status={status}>
        {config.map((v: HandleGetFlow['config'][0]) => {
          if (!v) {
            return null;
          }
          // let stepStatue = null; // 当前步骤以前,中间状态均为“success”
          // if (index + 1 < step) {
          //   stepStatue = 'wait';
          // } else if (index + 1 === step) {
          //   stepStatue = status;
          // }
          // @ts-expect-error Step上不存在 onClick属性
          return <Step title={v.title} onClick={() => this.handleButtonClick(v.hash, v.link)} />;
        })}
      </Steps>
    );
  };

  render() {
    const { tipConfig, notNeedCheck } = this.state;
    if (!tipConfig) {
      return null;
    }
    if (notNeedCheck) {
      this.flowConfig[1] = null;
    }
    if (!tipConfig.isSign) {
      this.flowConfig[3] = null;
    }
    if (tipConfig.status === 9) {
      tipConfig.status = 'error';
    } else {
      tipConfig.status = 'process';
    }
    return (
      <div className="home">
        <Header />
        <div className="home-page">
          <div className="home-header">
            {tipConfig.userName}
            ，你好，欢迎加入美团！
          </div>
          <div className="home-flow">
            {this.handleGetFlow({
              config: this.flowConfig,
              status: tipConfig.status,
              step: tipConfig.step,
            })}
          </div>
          <div className="home-tip-info">
            <div className="home-tip-info__wrapper">
              <TipInfo config={tipConfig} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Home;
